module.exports = __webpack_public_path__ + "Roboto-light.fc84e998bc29b297ea20321e4c90b6ed.hashedasset.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/Roboto/Roboto-light.ttf
// module id = 388
// module chunks = 8